import { render, staticRenderFns } from "./SelectedPages.vue?vue&type=template&id=5c804f5a&scoped=true&"
import script from "./SelectedPages.vue?vue&type=script&lang=js&"
export * from "./SelectedPages.vue?vue&type=script&lang=js&"
import style0 from "./SelectedPages.vue?vue&type=style&index=0&id=5c804f5a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c804f5a",
  null
  
)

export default component.exports